// export let hosts='https://api.thegeoint.com'
// export let hosts='https://localhost:8000'
// export let hosts='http://localhost:8000'
// export let hosts='https://np-moald-api.rimes.int';
export let hosts='https://care-lc-api.rimes.int';